import Scrum from './Scrum2';

export default Scrum;
